import styled from "styled-components";
import {Button} from "antd";
import {useEffect, useRef} from "react";

export const NextButton = styled(Button)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px 20px;
  height: 48px;
  background: ${props => props.theme.main || "#1D896D"} !important;
  border-radius: 50px;
  font-weight: 600;
  font-size: 16px;
  color: #FFFFFF !important;
  width: 100%;
  border: ${props => props.theme.main || "#1D896D"} !important;;

  &:disabled {
    opacity: 0.7;
  }
`;

export const Packages = styled((props) => {
    const divRef = useRef<any>();

    useEffect(() => {
        (async () => {
            setTimeout(() => {
                divRef.current.querySelector(".active")?.scrollIntoView({
                    behavior: "smooth",
                    inline: 'center',
                    block: 'nearest'
                });
            }, 500)
        })()
    }, [])

    return (
        <div  {...props} ref={divRef}>{props.children}</div>
    )
})`
  display: flex;
  flex-direction: row;
  align-items: center;
  overflow-x: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  justify-content: flex-start;
  margin: 0 0 24px 0;

  &::-webkit-scrollbar {
    display: none;
  }
`
export const PackageButton = styled.div`
  width: auto;
  display: flex;
  flex: 0 0 auto;
  flex-direction: row;
  -webkit-box-pack: center;
  justify-content: center;
  align-items: center;
  padding: 2px 16px;
  height: 44px;
  border: 1px solid rgb(221, 221, 221);
  backdrop-filter: blur(2px);
  border-radius: 8px;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: rgb(114, 124, 138);
  margin-right: 10px;
  cursor: pointer;

  & > span {
    max-width: 200px;
    display: inline-block;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }

  &.has-value {
    border-color: ${props => props.theme.main || "#2F967B"};
    color: ${props => props.theme.main || "#2F967B"};
  }

  &.active {
    background: ${props => props.theme.main || "#2F967B"};
    border: 1px solid #FFFFFF;
    color: #FFFFFF;
  }
`

export const ButtonGroup = styled.div`
  display: flex;
  align-items: center;
`;
export const ButtonSubmit = styled(NextButton)``;
export const ButtonCancel = styled(NextButton)`
  background: var(--ink-ink-200, #E9EEF6) !important;
  color: var(--black-black-700, #494949) !important;
`;